import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import React, { useState, useEffect } from "react";
import Service from "../../Service/firebase";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
	table: {
		minWidth: 450,
	},
	mv: {
		marginTop: 16,
		marginBottom: 16,
	},
});

export default function PrescriptionTable({
	prescribedDrugsList,
	fetchedData,
}) {
	const reduxDetails = useSelector((state) => state.personDetails);
	const classes = useStyles();
	const [prescribedDrugs, setPrescribedDrugs] = useState(prescribedDrugsList);
	const [isLoading, setIsLoading] = useState(true);

	const firebaseData = async () => {
		const res = await Service.getDrugdetails(reduxDetails.patientid);
		if (res === "error") {
			console.log("Error in get person details data");
		} else {
			setPrescribedDrugs(res);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		firebaseData();
	}, []);
	// console.log(prescribedDrugs?.map((r) => r.strength));
	let count = 0;
	return isLoading ? (
		<div className="addpersonpage">
			<i className="fas fa-spinner fa-pulse fa-2x"></i>
		</div>
	) : (
		<table className="table table-striped">
			<thead className="thead tablehead">
				<tr>
					<th scope="col">#</th>

					<th scope="col">Symptoms</th>
					<th scope="col">Drug Name</th>
					<th scope="col">Instructions</th>
					<th scope="col">Note</th>
					<th scope="col">Strength</th>
				</tr>
			</thead>
			{isLoading ? (
				<i className="fas fa-spinner fa-pulse fa-2x "></i>
			) : prescribedDrugs?.length === 0 ? (
				<tbody>
					<tr>
						<td>No info</td>
					</tr>
				</tbody>
			) : (
				<tbody className="tablebody">
					{prescribedDrugs &&
						prescribedDrugs?.map((p, index) => {
							count++;

							return (
								<tr key={index}>
									<td className="align-middle">{count}</td>

									<td className="align-middle">{p.symptom}</td>
									<td className="align-middle">{p.drugName}</td>
									<td className="align-middle">{p.instructions}</td>
									<td className="align-middle">{p.note}</td>
									<td className="align-middle">{p.strength.map((r) => r)}</td>
								</tr>
							);
						})}
				</tbody>
			)}
		</table>
	);
}
